import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { OperationsForecast } from './operationsforecast';

import { Tab } from './model';

export let OperationsForecastView = SuperCritical(({ model : { Model : { Ports } , CurrentTab } } : { model : OperationsForecast }) =>
    <section className="operations-forecast">
        <header>
            Operations Forecast
            <a href="#!schedulegrid?compact=1">View Compact</a>
        </header>

        {Ports().map(port => 
            <div className="port-operations">
                <h4>{port.Port() && port.Port()!.Name()}</h4>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            {port.Days().map((day, i) =>
                                <th>{
                                    i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                    "Day 3" 
                                }</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="right-align">Arrivals</td>
                            {port.Days().map(day =>
                                <td>{day.Arrivals()}</td>
                            )}
                        </tr>
                        <tr>
                            <td className="right-align">Departures</td>
                            {port.Days().map(day =>
                                <td>{day.Departures()}</td>
                            )}
                        </tr>
                        <tr>
                            <td className="right-align">Shifts</td>
                            {port.Days().map(day =>
                                <td>{day.Shifts()}</td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        )}

        <header>
            Pier-Side Services
            <a href="" onClick={noDefault(e => CurrentTab(Tab.Services))}>View Services</a>
        </header>

        {Ports().map(port => 
            <div className="port-operations">
                <h4>{port.Port() && port.Port()!.Name()}</h4>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            {port.Days().map((day, i) =>
                                <th>{
                                    i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                    "Day 3"
                                }</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            {port.Days().map(day =>
                                <td>{day.Services()}</td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        )}

        <header>
            Scheduled Vessels In Port
            <a href="#!?tab=1">View In-Port</a>
        </header>

        {Ports().map(port => 
            <div className="port-operations">
                <h4>{port.Port() && port.Port()!.Name()}</h4>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            {port.Days().map((day, i) =>
                                <th>{
                                    i === 0 ? "Today" :
                                    i === 1 ? "Tomorrow" :
                                    "Day 3"
                                }</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            {port.Days().map(day =>
                                <td>{day.ScheduledVessels()}</td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        )}

    </section>);




// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/operationsforecastview.tsx